export const ROLLBAR_IGNORED_MESSAGES = [
    'Script error',
    'ResizeObserver loop',
    "Failed to execute 'removeChild' on 'Node'",
    "Failed to execute 'selectNodeContents' on 'Range'"
];

export const ROLLBAR_HOST_SAFELIST = ['trainheroic.com'];

const EXTENSION_FRAME = /^(chrome|moz|safari|safari-web)-extension:\/\//i;
const VENDOR_FRAME =
    /(?:^|\/\/)(?:[^/]*\.)?(?:fast\.appcues\.com|cdn\.segment\.com|cdn\.cookielaw\.org)(?:\/|$)/i;

const framesFromPayload = payload => {
    const body = payload && payload.body;
    if (!body) {
        return [];
    }
    if (body.trace && body.trace.frames) {
        return body.trace.frames;
    }
    if (body.trace_chain && body.trace_chain[0] && body.trace_chain[0].frames) {
        return body.trace_chain[0].frames;
    }
    return [];
};

export const shouldBeIgnored = (_isUncaught, _args, payload) => {
    const frames = framesFromPayload(payload);
    if (frames.length === 0) {
        return true;
    }

    const filenames = frames.map(frame => (frame && frame.filename) || '');
    if (filenames.some(filename => /trainheroic\.com/i.test(filename))) {
        return false;
    }

    return filenames.every(
        filename =>
            !filename ||
            filename === '(unknown)' ||
            EXTENSION_FRAME.test(filename) ||
            VENDOR_FRAME.test(filename)
    );
};

export const rollbarNoiseFilters = {
    ignoredMessages: ROLLBAR_IGNORED_MESSAGES,
    hostSafeList: ROLLBAR_HOST_SAFELIST,
    hostWhiteList: ROLLBAR_HOST_SAFELIST,
    checkIgnore: shouldBeIgnored
};
